export default __webpack_public_path__ + "static/media/medical-small-1.e62b2755.png";